import Events16 from '@carbon/icons-react/es/events/16';
import UserFollow16 from '@carbon/icons-react/es/user--follow/16';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { Button } from 'components/atoms/button';
import { Loading } from 'components/atoms/loading';
import { GlobalInviteModal } from 'components/organisms/projects/global-invite/modal/modal';
import { ClickEventTags, setMarkerForDataDog } from 'hooks/use-data-dog-logger';
import { useProjectUsers } from 'hooks/use-project-users';
import { CustomAvatarGroup } from './custom-avatar-group';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AddUser = styled(UserFollow16)`
  color: var(--blue-60);
`;

export const AvatarInviteTrigger: FC<{
  projectId: number;
  showButton?: boolean;
}> = ({ projectId, showButton = false }) => {
  const [showInvitePopup, setshowInvitePopup] = useState(false);
  const {
    content: [, projectMembers = []],
    memberships: [status],
  } = useProjectUsers(ProjectId(projectId));

  if (status === 'loading') {
    return <Loading />;
  }

  return (
    <>
      <Container>
        {showButton ? (
          <Button
            onClick={() => {
              setMarkerForDataDog(ClickEventTags.ProjectPlanInviteMemberPopup);
              setshowInvitePopup(true);
            }}
            icon={<Events16 />}
            type="primary"
            iconPlacement="right"
            size="small"
            data-cy="btn.customer_project_plan.invite"
          >
            <FormattedMessage id="invite" />
          </Button>
        ) : (
          <Button
            size="small"
            type="text"
            onClick={() => {
              setMarkerForDataDog(ClickEventTags.ProjectPlanInviteMemberPopup);
              setshowInvitePopup(true);
            }}
            icon={<AddUser />}
            iconPlacement="right"
          >
            <CustomAvatarGroup projectMembers={projectMembers} />
          </Button>
        )}
      </Container>
      {showInvitePopup && (
        <GlobalInviteModal
          visible={showInvitePopup}
          handleOnClose={setshowInvitePopup}
          projectId={projectId}
        />
      )}
    </>
  );
};
